<template>

  <form>
    <div class="form-group">
      <label>ID da Company Page</label>
      <input
        v-autofocus
        type="text"
        class="form-control"
        v-model="settings.company_id"
        maxlength="60">
      <ValidateMessage :error="validateErrors['settings.company_id']" />
    </div>
  </form>

</template>

<script>
export default {
  name: 'IntegrationForm',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    },
    validateErrors: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      loading: false,
      settings: this.$clone(this.value || {})
    }
  },
  watch: {
    settings: {
      handler: function (newValue) {
        this.$emit('input', newValue)
      },
      deep: true
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/LinkedInLimitedListingsForm.vue